import { isNotLimited } from "PFApp/booking/components/booking_form/booking_form.utils";
import { BookingFormValues } from "PFApp/booking/components/booking_form/booking_form_values.types";
import { UpdateBookingPayload } from "PFApp/booking/services/api";

import { mapBasicSingleBooking } from "./get_payload.utils";
import { isBookingFormForSingleBookingEditModeValid } from "./validate";

export type GetPayloadsForEditGroupBookingsOfSingleType = {
  values: BookingFormValues;
  bookingGroupId?: number;
};

export const getPayloadsForEditGroupBookingsOfSingleType = ({
  values,
  bookingGroupId
}: GetPayloadsForEditGroupBookingsOfSingleType): UpdateBookingPayload[] => {
  const bookingsToProcess = values.bookings.filter(isNotLimited);
  if (!isBookingFormForSingleBookingEditModeValid({ ...values, bookings: bookingsToProcess })) {
    throw new Error("Invalid form values for editing a group booking!");
  }

  return bookingsToProcess.map((formBooking) => {
    const { category, title, description, overridesDiaryTime, overridesNonWorkingTime, phaseSourceId } =
      formBooking;
    return {
      ...mapBasicSingleBooking(formBooking),
      bookingCategoryId: category!.id,
      ...(title ? { title } : {}),
      description: description ?? "",
      ...(values.activityId ? { activityId: values.activityId } : {}),
      overridesCalendar: overridesDiaryTime!,
      overridesNonWorkingDays: overridesNonWorkingTime!,
      phaseSourceId,
      bookingGroupId
    };
  });
};
